import { Tag } from "antd"

import styles from "./cells.module.less"

// A program in a table (DAA-1-24): a borderless "CC" pill in the platform's light blue, "OI" in its
// light purple, as the design draws them — the colours of the program's lines in the charts.
const ProgramTag = ({ program }) => (
  <Tag bordered={false} className={styles[program]}>
    {program.toUpperCase()}
  </Tag>
)

export default ProgramTag
